import ProfileJourneyStageSection from './ProfileJourneyStageSection'

export default ProfileJourneyStageSection
export type { ProfileJourneyStageSectionProps } from './ProfileJourneyStageSection'
